import { collection, doc, getDoc, getDocs, query, setDoc, Timestamp, updateDoc, where } from "firebase/firestore"
import User from "../models/User"
import { db } from "../firebase";

const createUser = async (uid: string, email: string, displayName: string): Promise<User> => {
    const user: Partial<User> = {
        email,
        displayName,
        createdAt: Timestamp.fromDate(new Date()),
        updatedAt: Timestamp.fromDate(new Date()),
    }
    await setDoc(doc(db, "user", uid), user);
    user.uid = uid;
    return user as User;
}

const getUser = async (uid: string): Promise<User> => {
    const userSnapshot = await getDoc(doc(db, "user", uid));
    if (userSnapshot.exists()) {
        const user = userSnapshot.data() as User;
        user.uid = uid;
        return user;
    }
    throw new Error("User not found");
}

const getUserByEmail = async (email: string): Promise<User> => {
    const userRef = collection(db, "user");
    const q = query(userRef, where("email", "==", email));
    const userSnapshot = await getDocs(q);
    if (userSnapshot.empty) {
        throw new Error("User not found");
    }
    const user = userSnapshot.docs[0].data() as User;
    user.uid = userSnapshot.docs[0].id;
    return user;
}

const setSelectedTheme = async (user_id: string, theme_id : string | undefined) => {
    const colRef = doc(db, "user", user_id);
    const querySnapshot = await getDoc(colRef);
    if (querySnapshot.exists()) {
        const userData = querySnapshot.data() as User;
        userData.selectedTheme = theme_id;
        if(!theme_id) {
            delete userData.selectedTheme;
        }
        await setDoc(colRef, userData);
    } else {
        throw new Error("User not found");
    }
}

const UserController = {
    createUser,
    getUser,
    getUserByEmail,
    setSelectedTheme
}

export default UserController;